import { render, staticRenderFns } from "./garden14.vue?vue&type=template&id=4aba427e"
import script from "./garden14.vue?vue&type=script&lang=js"
export * from "./garden14.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports